
    <app-card-spinner [visible]="dataIsLoading" type="zero"></app-card-spinner>
    <div *ngFor="let item of items">
      <div class="connection-label">
        <strong>{{ item.name | translate }}</strong>
      </div>
      <div *ngFor="let subItem of item.values">
        <mat-checkbox
          [value]="subItem.value"
          [checked]="model.connessioni && model.connessioni.includes(subItem.value)"
          (change)="onChange(subItem.value)"
          [disabled]="to.disabled"
        >
          {{ subItem.viewValue }}
        </mat-checkbox>
      </div>
    </div>
  